import { render, staticRenderFns } from "./train.vue?vue&type=template&id=57e5912f"
import script from "./train.vue?vue&type=script&lang=js"
export * from "./train.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports